<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Week Wise Movie History Report") }}
      </div>
      <!-- <small
        ><em>{{ $t("* As Per show Date") }}</em></small
      > -->
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                ref="cinemaDropdown"
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
                :multiple="!isAllSelected"
                :close-on-select="isAllSelected"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedMovieName ? 'shift-up' : ''">
                {{ $t("Movie Name") }}
              </label>
              <multiselect
                v-model="selectedMovieName"
                :options="allMovieNames"
                track-by="movie_id"
                label="movie_name"
                :disabled="isRoleID"
                :searchable="true"
                placeholder=""
                :multiple="false"
              >
              </multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getMovieWiseData()"
            >
              {{ $t("fetch") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="movieWiseData.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- s -->

        <a
          target="_blank"
          @click="getMovieWiseData('Y', 'N')"
          title="Download as Excel"
          download
          style="cursor: pointer"
        >
          <img
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
        </a>
        <a
          target="_blank"
          @click="getMovieWiseData('N', 'Y')"
          title="Download as PDF"
          download
          style="cursor: pointer"
        >
          <img
            class="mx-1"
            src="@/assets/img/icons/pdf.svg"
            height="25"
            width="25"
          />
        </a>
      </div>

      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead>
            <tr style="background-color: rgb(200, 200, 200)">
              <th>Movie Name</th>
              <th colspan="2">Week 1</th>
              <th colspan="2">Week 2</th>
              <th colspan="2">Rest Weeks</th>
              <th colspan="2">Total</th>
            </tr>
            <tr style="background-color: rgb(200, 200, 200)">
              <th class="text-left"
                >Release Date -
                {{
                  movieReleaseDate
                    ? moment(movieReleaseDate).format("DD-MM-YYYY")
                    : ""
                }}</th
              >
              <th>Admits</th>
              <th>Revenue</th>
              <th>Admits</th>
              <th>Revenue</th>
              <th>Admits</th>
              <th>Revenue</th>
              <th>Admits</th>
              <th>Revenue</th>
            </tr>
          </thead>
          <template v-if="movieWiseData.length > 0">
            <tbody
              v-for="(movie, movieIndex) in movieWiseData"
              :key="movieIndex"
            >
              <tr>
                <td class="text-left">{{ movie.movie_name }}</td>
                <td class="text-right">{{ movie.weekWiseData.week1.admit }}</td>
                <td class="text-right">
                  {{ movie.weekWiseData.week1.revenue.toFixed(2) }}
                </td>
                <td class="text-right">{{ movie.weekWiseData.week2.admit }}</td>
                <td class="text-right">
                  {{ movie.weekWiseData.week2.revenue.toFixed(2) }}
                </td>
                <td class="text-right">
                  {{ movie.weekWiseData.restWeek.admit }}
                </td>
                <td class="text-right">
                  {{ movie.weekWiseData.restWeek.revenue.toFixed(2) }}
                </td>
                <td class="text-right">
                  {{ movie.weekWiseData.totalData.admit }}
                </td>
                <td class="text-right">
                  {{ movie.weekWiseData.totalData.revenue.toFixed(2) }}
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr style="background-color: #fff; font-weight: bold">
                <td class="text-left">{{ $t("Grand Total") }}</td>
                <td class="text-right">{{ grandTotal.week1.admit }}</td>
                <td class="text-right">
                  {{ grandTotal.week1.revenue.toFixed(2) }}
                </td>
                <td class="text-right">{{ grandTotal.week2.admit }}</td>
                <td class="text-right">
                  {{ grandTotal.week2.revenue.toFixed(2) }}
                </td>
                <td class="text-right">{{ grandTotal.restWeek.admit }}</td>
                <td class="text-right">
                  {{ grandTotal.restWeek.revenue.toFixed(2) }}
                </td>
                <td class="text-right">{{ grandTotal.total.admit }}</td>
                <td class="text-right">
                  {{ grandTotal.total.revenue.toFixed(2) }}
                </td>
              </tr>
            </tbody>
          </template>
          <tbody v-else>
            <tr>
              <td colspan="11">
                <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        movieWiseData: [],

        excelFilePath: "",
        grandTotal: {},
        //   selectedMovieName: [],
        selectedMovieName: null,
        allMovieNames: [],
        grandTotal: {},
        movieReleaseDate: null,
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      const { cinema_id } = this.secureStore.get("USINFO");
      this.getCinemaList(cinema_id);
      this.getMovieList();
    },
    watch: {
      selectedMovieName(newVal) {
        console.log("Selected Movie:", newVal);
      },
    },
    computed: {
      isAllSelected() {
        return (
          this.dropDown.selectedCinema &&
          this.dropDown.selectedCinema.length === 1 &&
          this.dropDown.selectedCinema[0].cine_id === "all"
        );
      },
    },

    mounted() {},
    methods: {
      moment,
      getCinemaList: function(cinema_id) {
        MasterService.GetCinemas({cine_id: cinema_id})
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              // this.dropDown.cinemas = data.Records;
              if(cinema_id) {
                this.dropDown.cinemas = data.Records;
              } else {
                this.dropDown.cinemas = [
                  { cine_id: "all", cine_name: this.$t("All Cinemas") },
                  ...data.Records,
                ];
              }
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getMovieList: function() {
        ReportsService.GetTransactionsMovieName().then((response) => {
          const { data } = response;
          console.log("data:", data);
          if (data.status && data.Records.length > 0) {
            this.allMovieNames = [...data.Records];
            // console.log('this.allMovieNames:', this.allMovieNames);
          } else {
            this.$toasted.show(data.message);
          }
        });
      },
      // onSelectCinema: function (event) {
      //   this.dropDown.selectedCinema = event;
      //   this.dropDown.selectedCinemaName = event.cine_name;
      //   this.dropDown.selectedCinemaId = event.cine_id;
      //   this.$store.dispatch("selectDropdownCinema", event);
      // },

      onSelectCinema: function(event) {
        if (event.some((cinema) => cinema.cine_id === "all")) {
          this.dropDown.selectedCinema = this.dropDown.cinemas.filter(
            (cinema) => cinema.cine_id === "all"
          );
          this.$refs.cinemaDropdown.close();
        } else {
          this.dropDown.selectedCinema = this.dropDown.selectedCinema.filter(
            (cinema) => cinema.cine_id !== "all"
          );
        }
        this.dropDown.selectedCinemaName = this.dropDown.selectedCinema.map(
          (cinema) => cinema.cine_name
        );
        this.dropDown.selectedCinemaId = this.dropDown.selectedCinema.map(
          (cinema) => cinema.cine_id
        );
        this.$store.dispatch("selectDropdownCinema", event);
      },

      getMovieWiseData(isExcel = "N", isPdf = "N", type = "") {
        this.movieWiseData = [];
        if (!this.dropDown.selectedCinema.length) {
          return this.$toasted.show("Select Cinema");
        }

        if (!this.selectedMovieName) {
          return this.$toasted.show("Select Movie");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinema.map((cinemas) => {
            return cinemas.cine_id;
          }),
          cinema_name: this.dropDown.selectedCinema.map((cinemas) => {
            return cinemas.cine_name;
          }),
          cinema_address: this.dropDown.selectedCinema.map((cinemas) => {
            return cinemas.cine_address;
          }),
          isPdf,
          isExcel,
        };

        if (this.selectedMovieName) {
          payload["selectedMovieName"] = this.selectedMovieName;
        }

        ReportsService.GetWeekWiseMovieCollectionReport(payload)
          .then((response) => {
            const { data } = response;
            if (!data.status) return this.$toasted.show(data.message);
            if (data.status && data.Records.length > 0) {
              this.movieWiseData = [...data.Records];
              this.grandTotal = data.grandTotal;
              this.movieReleaseDate =
                data.Records[0].transactionsData[0].original_release_date;

              // console.log("this.movieReleaseDate",this.movieReleaseDate)
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid gray;
  }
  .swc-report-table td {
    white-space: nowrap;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid gray !important;
  }
  .swc_table_header th {
    border: 1px solid gray !important;
  }
  .no_border {
    border: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/weekWiseMovieReport.vue